import { defineStore } from "pinia";
import { store } from "../index";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import en from "element-plus/es/locale/lang/en";
import es from "element-plus/es/locale/lang/es";
import { useStorage } from "@/hooks/web/useStorage";
import { LocaleDropdownType } from "@/components/LocaleDropdown";

const { getStorage, setStorage } = useStorage("localStorage");

const elLocaleMap: Record<string, typeof zhCn> = {
  zh_CN: zhCn,
  en_US: en,
  es_ES: es,
};
interface LocaleState {
  currentLocale: LocaleDropdownType;
  localeMap: LocaleDropdownType[];
}

export const useLocaleStore = defineStore("locales", {
  state: (): LocaleState => {
    return {
      currentLocale: {
        lang: getStorage("lang") || "en_US",
        elLocale:
          elLocaleMap[getStorage("lang") || "en_US"] ?? elLocaleMap.en_US,
      },
      // 多语言
      localeMap: [
        // {
        //   lang: "zh_CN",
        //   name: "简体中文",
        // },
        {
          lang: "en_US",
          name: "English",
        },
        {
          lang: "es_ES",
          name: "Español",
        },
      ],
    };
  },
  getters: {
    getCurrentLocale(): LocaleDropdownType {
      return this.currentLocale;
    },
    getLocaleMap(): LocaleDropdownType[] {
      return this.localeMap;
    },
  },
  actions: {
    setCurrentLocale(localeMap: LocaleDropdownType) {
      // this.locale = Object.assign(this.locale, localeMap)
      this.currentLocale.lang = localeMap?.lang;
      this.currentLocale.elLocale =
        elLocaleMap[localeMap?.lang] ?? elLocaleMap.en_US;
      setStorage("lang", localeMap?.lang);
    },
  },
});

export const useLocaleStoreWithOut = () => {
  return useLocaleStore(store);
};
